function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { KYBProgressStatusEnum } from 'anchor-kyb-service/types';
import { Button, Callout, Typography } from 'seagull';
import { openInNewTabProps } from "../../constants";
import { useStore } from "../../contexts";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { selectors } from "../../store/state-selectors";
import styles from "./HomePage.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export function MissingColumnBankAccountBanner() {
  const showMissingColumnBankAccountBanner = useStore(selectors.showMissingColumnBankAccountBanner);
  const {
    KYB_VERIFICATION
  } = useFeatureFlags();
  return showMissingColumnBankAccountBanner && !KYB_VERIFICATION ? /*#__PURE__*/_jsx(Callout, {
    hideIcon: true,
    intent: "warning",
    "data-testid": "missing-column-bank-account-banner",
    withAction: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      as: "a",
      href: "https://book.avoma.com/anchor/3-day-ach-migration",
      skin: "darkSecondary"
    }, openInNewTabProps), {}, {
      children: "Schedule call"
    })),
    children: "To enable 3-day ACH payments, please schedule a 5-minute call with our team to update your bank details. Note that a firm owner listed during the KYB process must attend with a valid ID."
  }) : null;
}
export function EnablePaymentsBanner() {
  const hasDisabledPayments = useStore(selectors.user.hasDisabledPayments);
  const personaKYBStatus = useStore(s => {
    var _s$personaKYBStatus$d;
    return (_s$personaKYBStatus$d = s.personaKYBStatus.data) === null || _s$personaKYBStatus$d === void 0 ? void 0 : _s$personaKYBStatus$d.status;
  });
  const {
    KYB_VERIFICATION
  } = useFeatureFlags();
  const isKYBApproved = personaKYBStatus === KYBProgressStatusEnum.Approved;
  return hasDisabledPayments && isKYBApproved && KYB_VERIFICATION ? /*#__PURE__*/_jsx(Callout, {
    hideIcon: true,
    intent: "warning",
    "data-testid": "enable-payments-banner",
    className: styles.enablePaymentsBanner,
    withAction: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      as: "a",
      "data-testid": "enable-payments-banner-button",
      href: "https://book.avoma.com/anchor/enable-payments/",
      skin: "darkSecondary"
    }, openInNewTabProps), {}, {
      children: "Schedule call"
    })),
    children: /*#__PURE__*/_jsx(Typography, {
      children: "To enable payments, the business owner needs to complete a short identity verification. Schedule a quick 5-minute video call with our team and have their photo ID ready."
    })
  }) : null;
}